var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7 21.8V20.3H8.2H6C5.72386 20.3 5.5 20.0761 5.5 19.8V7C5.5 6.72386 5.72386 6.5 6 6.5H26C26.2761 6.5 26.5 6.72386 26.5 7V19.8C26.5 20.0761 26.2761 20.3 26 20.3H17.2H16.6405L16.2176 20.6665L11.7637 24.5265L9.7 26.0399V21.8ZM9.79136 27.833L12.7 25.7L17.2 21.8H26C27.1046 21.8 28 20.9046 28 19.8V7C28 5.89543 27.1046 5 26 5H6C4.89543 5 4 5.89543 4 7V19.8C4 20.9046 4.89543 21.8 6 21.8H6.7H8.2V23.3V27.0266C8.2 27.8457 9.13084 28.3174 9.79136 27.833ZM16.0019 12C15.1734 12 14.5 12.6716 14.5 13.5C14.5 14.3284 15.1734 15 16.0019 15C16.8303 15 17.5037 14.3284 17.5037 13.5C17.5037 12.6716 16.8303 12 16.0019 12ZM20 13.5C20 12.6716 20.6734 12 21.5019 12C22.3303 12 23.0037 12.6716 23.0037 13.5C23.0037 14.3284 22.3303 15 21.5019 15C20.6734 15 20 14.3284 20 13.5ZM10.5019 12C9.67342 12 9 12.6716 9 13.5C9 14.3284 9.67342 15 10.5019 15C11.3303 15 12.0037 14.3284 12.0037 13.5C12.0037 12.6716 11.3303 12 10.5019 12Z",
    fill: "#8A8A8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIcon3);
export default __webpack_public_path__ + "static/media/m-icon-3.a93f9eb6d6de98df7b67a2a9a4255e14.svg";
export { ForwardRef as ReactComponent };